import { render, staticRenderFns } from "./BackgroundMockup.vue?vue&type=template&id=8b3fb7c2&"
import script from "./BackgroundMockup.vue?vue&type=script&lang=js&"
export * from "./BackgroundMockup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports